import {Toast} from "bootstrap";

export default function(root) {
	Array.from(root.querySelectorAll('.toast'))
		.forEach(toastNode => {
				new Toast(toastNode, {
					autohide: true,
					delay: 15 * 1000,
				}).show()

				toastNode.addEventListener('hidden.bs.toast', () => {
					Toast.getInstance(toastNode).dispose()
					toastNode.remove()
				})
			})
}
